<template>
  <div>
    <!-- <div @click="showDialog" @mouseenter="stop" @mouseleave="continuePlay" v-if="notice.length && isVertical" class="vertical-com">
      <swiper style="height: 84px" class="swiper-no-swiping" :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="item in notice" :key="item.id">
          <div class="swiper-item">
            <p class="title">{{item.name}}</p>
            <div class="content-wrap">
              <p class="content">{{item.content}}</p>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div> -->
    <div class="marquree-wrap" v-if="notice.length > 0">
      <div v-if="!isVertical" style="display:flex;align-content: center;margin-top:10px;">
        <div class="speaker">
          NOTICE
        </div>
        <marquee onmouseover="this.stop();" onmouseout="this.start();" scrollamount="8"
          scrolldelay="150" style="cursor: pointer;line-height: 38px">
          <span class="marquee_item" @click="handClickShowDialog" v-for="(item,index) in notice" :title="item.name" :key="index">{{item.content}}</span>
        </marquee>
      </div>
    </div>
     <dialogTem  append-to-body :visible.sync="mquerrDialog" :diaTitle="$t('createdDislaog.Announcement')" :diaWidth="'780px'" :deposit="'marquee'">
      <div class="marquee_wordSwiper">
        <ul class="_ul">
          <li v-for="(item,index) in notice" :key="index" class="marquerr_ele">
            <!-- <p class="title">{{item.createTime | timeFilter}}</p> -->
            <span class="content">{{item.content}}</span>
          </li>
        </ul>
      </div>
    </dialogTem>
  </div>
</template>

<script>
import dialogTem from '../dialogTem.vue'
  import { mapState, mapMutations } from 'vuex';
  import { swiper, swiperSlide } from 'vue-awesome-swiper';
  import { filter } from '@/common/index'
  import 'swiper/dist/css/swiper.css';
  export default {
    name: 'marqueeN',
    props: {
      isVertical: {
        default: false,
        type: Boolean
      },
      isWhite: {
        default: false,
        type: Boolean
      }
    },
    components: { swiper,dialogTem,swiperSlide, },
    filters: {
      timeFilter(time) {
        return filter.getTimeYDMS(time)
      }
    },
    data() {
      return {
        notice: [],
        mquerrDialog: false,
        // swiperOption: { // 轮播
        //   direction: 'vertical',
        //   loop: true,
        //   autoplay: {
        //     delay: 4000,
        //     disableOnInteraction: false
        //   },
        // },
      }
    },
    computed: {
      ...mapState({ frontType: state => state.frontType}),
      swiper() {
        if (this.notice.length) {
          return this.$refs.mySwiper.swiper
        }
      }
    },
    methods: {
      continuePlay() { this.swiper.autoplay.start() },
      stop() { this.swiper.autoplay.stop() },
      handClickShowDialog() { this.mquerrDialog = !this.mquerrDialog },
      pushInfoList() {
        this.$api.post(this.$urls.HOMEBEFORE.PUSHINFOLIST, {frontType: 2}, resp => {
          if (resp.data.code === 200) {
            this.notice = resp.data.data.list;
          } else {
            this.notice = []
          }
        }, err => {})
      },
    },
    mounted() { this.pushInfoList() },
    activated() { this.pushInfoList()},
    deactivated() { this.notice = [] }
  };
</script>

<style scoped lang="scss">
  @import '../../../style/variable.scss';
  .marquree-wrap{
    .marquee_item{
      font-family: Roboto-Regular;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #fff;
    }
    .speaker{
      border-radius: 16px 0px 0px 16px;
      background: #FFFFFF;
      display:inline-block;
      line-height: 38px;
      padding:0 20px;
      text-align: right;
    }
    marquee{
      border-radius: 0px 16px 16px 0px;
      background-color: #434343
      
    }
  }
  .marquee_wordSwiper{
    height:420px;
    overflow:auto;
    ._ul{ margin: 0 18px;}
    .marquerr_ele{
      margin-bottom:40px;
      font-family: Roboto-Regular;
      font-size: 18px;
      color: #222;
      &::before{
        content: '';
        display:inline-block;
        width:8px;
        height:8px;
        margin-right:8px;
        border-radius: 50%;
        background:#b5b5b5;
      }
    }
  }
  /* 设置滚动条的样式 */
::-webkit-scrollbar {width:8px;height:30px;}
::-webkit-scrollbar-track-piece { //滚动条凹槽的颜色，还可以设置边框属性
  background-color:#fff;
  border:none;
}
::-webkit-scrollbar-thumb {
  border-radius:4px;
  background-color: #dfdfdf;
}
</style>



// WEBPACK FOOTER //
// src/pages/build902/components/common/marquee/marquee-news.vue